/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
import getQueryString from './getQueryString';
const LEADIN_CONFIG = 'LEADIN_CONFIG';
const leadinConfigKeys = {
  l: 'language',
  php: 'phpVersion',
  wp: 'wpVersion',
  v: 'leadinPluginVersion',
  theme: 'theme',
  admin: 'admin'
};
let cachedQueryString;
export default function getLeadinConfig() {
  try {
    if (typeof cachedQueryString !== 'undefined') {
      return cachedQueryString;
    }

    let queryParams = {};

    try {
      queryParams = JSON.parse(sessionStorage.getItem(LEADIN_CONFIG) || '') || {};
    } catch (e) {//
    }

    const search = getQueryString();
    const pairs = search.slice(1).split('&');
    pairs.forEach(pair => {
      const [key, value] = pair.split('=');

      if (leadinConfigKeys.hasOwnProperty(key)) {
        queryParams[leadinConfigKeys[key]] = decodeURIComponent(value || '');
      }
    });
    cachedQueryString = queryParams;

    try {
      sessionStorage.setItem(LEADIN_CONFIG, JSON.stringify(queryParams));
    } catch (e) {//
    }

    return queryParams;
  } catch (e) {
    return {};
  }
}
export function clearCachedQueryStringForTests() {
  cachedQueryString = undefined;
}